const normalizeSearchValue = (value) => String(value || "").toLocaleLowerCase("pt-BR");

export const buildPassengerSelectionList = ({
  people = [],
  selectedIds = [],
  search = "",
} = {}) => {
  const term = normalizeSearchValue(search).trim();
  const selected = new Set(selectedIds.map(Number));

  return people
    .map((person, originalIndex) => ({
      person,
      originalIndex,
      isSelected: selected.has(Number(person.id)),
    }))
    .filter(({ person }) => (
      !term
      || [person.nome, person.bairro, person.regiao]
        .some((value) => normalizeSearchValue(value).includes(term))
    ))
    .sort((left, right) => (
      Number(right.isSelected) - Number(left.isSelected)
      || left.originalIndex - right.originalIndex
    ))
    .map(({ person }) => person);
};
